// extracted by mini-css-extract-plugin
module.exports = {"circle-slot":"circle-slot-d30fe84b"};